export default __webpack_public_path__ + "static/person-36eb0b73352a086ee6ee6a3f7ad77feb.png";